import { KIROV_STATION_ID, WEATHER_STATION_KEY } from './types'

export function readStoredStation(): string {
  try {
    return localStorage.getItem(WEATHER_STATION_KEY) || KIROV_STATION_ID
  } catch {
    return KIROV_STATION_ID
  }
}

export function saveStoredStation(stationId: string) {
  try {
    localStorage.setItem(WEATHER_STATION_KEY, stationId)
  } catch {
    /* ignore */
  }
}

export function formatTemp(value?: number | string | null): string {
  if (value == null || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return String(value)
  return `${Math.round(n)}°C`
}

export function formatForecastDate(dt?: string): string {
  if (!dt) return '—'
  const d = new Date(dt)
  if (Number.isNaN(d.getTime())) return dt
  return d.toLocaleDateString('ru-RU', { weekday: 'short', day: 'numeric', month: 'short' })
}

export function formatReadingLabel(iso: string, days: number): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  if (days <= 1) {
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
  }
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function isKirovStation(stationId: string): boolean {
  return String(stationId) === KIROV_STATION_ID
}
